/**
 * Calculate total count from all tabs in tablist
 * @param {Array} tabList - Array of tab objects with id property
 * @param {Object} searchDetails - Search details object from state (newState?.searchDetails)
 * @return {number} Total count from all tabs
 */
export const getTotalTabCount = (tabList = [], searchDetails = {}) => {
  if (!Array.isArray(tabList) || tabList.length === 0) {
    return 0
  }

  return tabList.reduce((total, tab) => {
    const tabCount = searchDetails?.[tab?.id]?.count || 0
    return total + tabCount
  }, 0)
}
